import { Injectable } from '@angular/core';

import { Global } from '../../../app.global';

@Injectable()
export class QuestionsConst {

  public clarificationType = this.global.questionTypes['0'];
  public prologueType = this.global.questionTypes['1'];
  public noneType = this.global.questionTypes['-1'];

  public confirmationClass = this.global.questionClasses['0'];
  public yesNoClass = this.global.questionClasses['1'];
  public multipleAnswerClass = this.global.questionClasses['2'];
  public multipleChoiceClass = this.global.questionClasses['3'];
  public freeTextClass = this.global.questionClasses['4'];
  public freeTextDateClass = this.global.questionClasses['5'];
  public freeTextPositiveNumberClass = this.global.questionClasses['6'];
  public freeTextNoValidationClass = this.global.questionClasses['7'];
  public confirmationQuestionClass = this.global.questionClasses['8'];

  public noActionAction = this.global.decisionActions['0'];
  public createBespokeLetterAction = this.global.decisionActions['1'];

  constructor(public global: Global) { }

}
